<template>
  <div id="kt_wrapper">
    <div
      class="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
      id="kt_content"
    >

      <!-- begin:: Content -->
      <div class="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid mb-7">

        <!--begin::Row-->

        <div class="kt-portlet no-shadow transparent">
          <div class="kt-portlet__body flex-sm-row justify-content-between align-items-center">
            <div class="kt-portlet__head">
              <div class="kt-portlet__head-label">
                <h3 class="kt-portlet__head-title">
                  (404) {{ $t('app.page.not.found') }}
                </h3>
              </div>
            </div>
            <div class="kt-portlet__content">
            </div>
          </div>
        </div>
      </div>
    </div>
</div>
</template>

<script>
export default {
  name: 'NotFound',
  mounted() {
    this.$Progress.finish();
  },
};
</script>

<style scoped>

</style>
